/* =============================================================
   ARGOING — STANDARD UNICO · comportamenti
   Un solo file per tutto il negozio.
   1. etichette delle opzioni (Taglia:, Colore guscio: ...)
   2. caselle variante con FOTO reale e PREZZO della combinazione
   3. galleria foto su una riga con le frecce
   v1 · 15-10-2026
   ============================================================= */
(function () {
  'use strict';

  /* ---------- utilita ---------- */
  function euro(cents) {
    if (cents == null || isNaN(cents)) return '';
    var n = Math.round(cents / 100);
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }
  function thumb(src, w) {
    if (!src) return null;
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- dati del prodotto ---------- */
  function prodotto() {
    var s = document.querySelector('script[type="application/json"][data-section-type="static-product"]');
    if (!s) return null;
    var d;
    try { d = JSON.parse(s.textContent); } catch (e) { return null; }
    var p = d.product || (d.data && d.data.product) || d;
    if (p && Array.isArray(p.variants) && p.variants.length) return p;
    // a volte il prodotto e annidato di un livello
    for (var k in d) {
      if (d[k] && Array.isArray(d[k].variants) && d[k].variants.length) return d[k];
    }
    return null;
  }

  /* ---------- il motore delle caselle ---------- */
  function Selettore(p) {
    var box = document.querySelector('[data-options-selection], .options-selection, form[action*="/cart/add"]');
    var gruppi = [].slice.call(document.querySelectorAll('fieldset.options-selection__radios'));
    if (!gruppi.length || !p) return;

    var nomi = (p.options || []).map(function (o) { return (typeof o === 'string') ? o : o.name; });

    /* nomi delle opzioni per ogni gruppo, letti dagli input */
    var info = gruppi.map(function (g) {
      var inp = g.querySelector('input[type="radio"]');
      var nome = inp ? inp.getAttribute('name') : '';
      var idx = nomi.indexOf(nome);
      if (idx < 0) idx = gruppi.indexOf(g);
      return { el: g, nome: nome, idx: idx };
    });

    /* 1. ETICHETTA: il tema la lascia vuota in italiano e la riscrive
          a ogni cambio, quindi ne mettiamo una nostra accanto. */
    info.forEach(function (gi) {
      var leg = gi.el.querySelector('.options-selection__option-header') || gi.el;
      if (leg.querySelector('.agV-eti')) return;
      var mia = document.createElement('span');
      mia.className = 'agV-eti';
      mia.setAttribute('data-ag-nome', gi.nome);
      leg.appendChild(mia);
      gi.eti = mia;
    });

    /* 2. FOTO sulle caselle: una per ogni valore che ha un'immagine propria */
    function fotoPerValore(idx) {
      var m = {};
      (p.variants || []).forEach(function (v) {
        var val = v['option' + (idx + 1)];
        if (!val || m[val]) return;
        var img = v.featured_image && v.featured_image.src;
        if (img) m[val] = { src: img, alt: (v.featured_image.alt || val) };
      });
      return m;
    }

    /* l'opzione che merita la foto: quella con piu immagini distinte */
    var conFoto = -1, maxDistinte = 1;
    info.forEach(function (gi) {
      var m = fotoPerValore(gi.idx);
      var srcs = {}, n = 0;
      for (var k in m) { if (!srcs[m[k].src]) { srcs[m[k].src] = 1; n++; } }
      if (n > maxDistinte) { maxDistinte = n; conFoto = gi.idx; }
    });

    if (conFoto >= 0) {
      var mappa = fotoPerValore(conFoto);
      var gi = info.filter(function (x) { return x.idx === conFoto; })[0];
      if (gi) {
        gi.el.classList.add('agV-gruppo--foto');
        [].slice.call(gi.el.querySelectorAll('.options-selection__option-value')).forEach(function (cel) {
          var inp = cel.querySelector('input[type="radio"]');
          if (!inp) return;
          var f = mappa[inp.value];
          if (!f || cel.querySelector('.agV-foto')) return;
          var lab = cel.querySelector('label') || cel;
          var im = document.createElement('span');
          im.className = 'agV-foto';
          im.style.backgroundImage = 'url("' + thumb(f.src, 200) + '")';
          im.setAttribute('role', 'presentation');
          lab.insertBefore(im, lab.firstChild);
        });
      }
    }

    /* 3. PREZZO su ogni casella: quello che faresti scegliendola */
    function scelteCorrenti() {
      var s = [];
      info.forEach(function (gi) {
        var c = gi.el.querySelector('input[type="radio"]:checked');
        s[gi.idx] = c ? c.value : null;
      });
      return s;
    }
    function trovaVariante(s) {
      return (p.variants || []).filter(function (v) {
        for (var i = 0; i < s.length; i++) {
          if (s[i] == null) continue;
          if (v['option' + (i + 1)] !== s[i]) return false;
        }
        return true;
      })[0];
    }

    function aggiorna() {
      var cur = scelteCorrenti();
      var base = trovaVariante(cur);
      var basePrezzo = base ? base.price : null;

      info.forEach(function (gi) {
        /* etichetta: nome opzione + valore scelto */
        var span = gi.eti || gi.el.querySelector('.agV-eti');
        if (span) {
          var sel = gi.el.querySelector('input[type="radio"]:checked');
          span.textContent = gi.nome + (sel ? ': ' + sel.value : '');
        }

        [].slice.call(gi.el.querySelectorAll('.options-selection__option-value')).forEach(function (cel) {
          var inp = cel.querySelector('input[type="radio"]');
          if (!inp) return;
          var ipo = cur.slice();
          ipo[gi.idx] = inp.value;
          var v = trovaVariante(ipo);

          var tag = cel.querySelector('.agV-prezzo');
          if (!tag) {
            tag = document.createElement('span');
            tag.className = 'agV-prezzo';
            (cel.querySelector('label') || cel).appendChild(tag);
          }

          if (!v) { tag.textContent = 'non disponibile'; cel.classList.add('agV--no'); return; }
          cel.classList.remove('agV--no');
          cel.classList.toggle('agV--esaurito', v.available === false);

          if (basePrezzo != null && v.price === basePrezzo) {
            tag.textContent = euro(v.price);
            tag.className = 'agV-prezzo agV-prezzo--pari';
          } else if (basePrezzo != null && v.price > basePrezzo) {
            tag.textContent = euro(v.price);
            tag.className = 'agV-prezzo agV-prezzo--su';
          } else {
            tag.textContent = euro(v.price);
            tag.className = 'agV-prezzo agV-prezzo--giu';
          }
        });
      });
    }

    gruppi.forEach(function (g) {
      g.addEventListener('change', function () { setTimeout(aggiorna, 0); });
      g.addEventListener('click', function () { setTimeout(aggiorna, 40); });
    });
    aggiorna();
    document.documentElement.classList.add('agV-on');
  }

  /* ---------- galleria: frecce sulla riga delle miniature ---------- */
  function Galleria() {
    [].slice.call(document.querySelectorAll('product-gallery .product-gallery__navigation'))
      .forEach(function (nav) {
        if (nav.parentNode.classList.contains('agMini')) return;
        var wrap = document.createElement('div');
        wrap.className = 'agMini';
        nav.parentNode.insertBefore(wrap, nav);
        wrap.appendChild(nav);

        function freccia(dir) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'agMini-fr agMini-fr--' + (dir < 0 ? 'sx' : 'dx');
          b.setAttribute('aria-label', dir < 0 ? 'Foto precedenti' : 'Foto successive');
          b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="' +
            (dir < 0 ? '15 5 8 12 15 19' : '9 5 16 12 9 19') + '"/></svg>';
          b.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            nav.scrollBy({ left: dir * Math.max(180, nav.clientWidth * 0.7), behavior: 'smooth' });
          });
          return b;
        }
        var sx = freccia(-1), dx = freccia(1);
        wrap.appendChild(sx); wrap.appendChild(dx);

        function stato() {
          var over = nav.scrollWidth - nav.clientWidth > 4;
          sx.hidden = !over || nav.scrollLeft <= 2;
          dx.hidden = !over || nav.scrollLeft >= nav.scrollWidth - nav.clientWidth - 2;
        }
        nav.addEventListener('scroll', stato, { passive: true });
        window.addEventListener('resize', stato);
        setTimeout(stato, 150); setTimeout(stato, 700);
      });
  }


  /* ---------- linguette delle schede prodotto v10 ---------- */
  function Linguette(){
    document.addEventListener('click', function(ev){
      var b = ev.target.closest && ev.target.closest('.agD-ling button[data-agd-pan]');
      if (!b) return;
      ev.preventDefault();
      var barra = b.parentNode, scheda = barra.closest('#agD') || document;
      [].forEach.call(barra.querySelectorAll('button[data-agd-pan]'), function(x){
        x.setAttribute('aria-selected','false');
        var p = scheda.querySelector('#' + x.getAttribute('data-agd-pan'));
        if (p) p.hidden = true;
      });
      b.setAttribute('aria-selected','true');
      var pan = scheda.querySelector('#' + b.getAttribute('data-agd-pan'));
      if (pan) pan.hidden = false;
    });
  }

  ready(function () {
    var p = prodotto();
    try { if (p) Selettore(p); } catch (e) { }
    try { Galleria(); } catch (e) { }
    try { Linguette(); } catch (e) { }
  });

  /* il tema ricarica pezzi di pagina: riproviamo quando cambia */
  document.addEventListener('variant:change', function () {
    try { Galleria(); } catch (e) { }
  });
})();
